export default "__VITE_ASSET__mlHkL8UY__"